export default __webpack_public_path__ + "/dist/images/9160506.png";